module.exports = __webpack_public_path__ + "./assets/img_hualien_grey@2x__135b251c3cf3cea1fe76d5290a6e6bf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_hualien_grey@2x.jpg
// module id = 628
// module chunks = 12